import type { Event } from "@/lib/api-types";
import { EventCard } from "@/components/events/EventCard";
import { Card, CardBody } from "@/components/ui/Card";
import { cn } from "@/lib/utils";

interface HomeEventCardProps {
  event: Event;
  className?: string;
  variant?: "default" | "slideshow";
}

export function HomeEventCard({
  event,
  className,
  variant = "default",
}: HomeEventCardProps) {
  return (
    <EventCard
      event={event}
      variant={variant}
      className={cn("border border-border/60 shadow-sm", className)}
    />
  );
}

export function HomeEventsEmptyState() {
  return (
    <Card variant="elevated">
      <CardBody className="text-center">
        <p className="text-sm text-muted">
          No upcoming events listed right now. Check back soon or reach out to
          learn more about community activities.
        </p>
      </CardBody>
    </Card>
  );
}
